import { render, staticRenderFns } from "./kids_class_v2.vue?vue&type=template&id=3da95199&scoped=true&"
import script from "./kids_class_v2.vue?vue&type=script&lang=js&"
export * from "./kids_class_v2.vue?vue&type=script&lang=js&"
import style0 from "./kids_class_v2.vue?vue&type=style&index=0&id=3da95199&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da95199",
  null
  
)

export default component.exports